import React from "react";
import { Button, Form, Input } from "antd";

const Filters = ({ onChange }) => {
  return (
    <Form layout="inline" onFinish={(values) => onChange(values)}>
      <Form.Item label={null} name="barcode" style={{ width: 350 }}>
        <Input placeholder="Gönderi Barkodu" />
      </Form.Item>
      <Form.Item style={{ width: 120 }}>
        <Button type="primary" block htmlType="submit">
          Rapor Sorgula
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Filters;
